/* eslint-disable */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    load: "languageOnly",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      order: ["navigator", "localStorage"],
      caches: ["localStorage"],
    },
    lng: localStorage.getItem("i18nextLng") || "en",
    fallbackLng: "en",
  });

export default i18n;
